"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkCell = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var linkStyle = { display: 'inline' };
exports.LinkCell = function (props) {
    var column = props.column, row = props.row, value = props.value;
    var cellRoute = column.columnCode.split('.');
    var ttableRow = cellRoute.reduce(function (currentRow, currentRoute) { return currentRow && currentRow[currentRoute]; }, row.original);
    if (!ttableRow) {
        return value || '';
    }
    var url = ttableRow.url, title = ttableRow.title, color = ttableRow.color, isOpenInNewWindow = ttableRow.isOpenInNewWindow, underline = ttableRow.underline;
    var textValue = title || value;
    var linkColor = color && {
        color: color,
    };
    var style = __assign(__assign({}, linkStyle), linkColor);
    var target = isOpenInNewWindow && {
        target: '_blank',
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, url ? (react_1.default.createElement(core_1.Link, __assign({}, target, { style: style, href: url, underline: underline }), textValue)) : (textValue)));
};
